import { useContext, useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import ConfirmationModal from '../../ConfirmationModal';
import { StoreContext } from '../../Store';
import DataTable from '../../DataTable';

const CustomaiteModal = ({ show, onHide, onSubmit, loading, error, documentsList = [] }) => {
  const store = useContext(StoreContext);

  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const handleClose = () => {
    if (!loading) {
      onHide();
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered dialogClassName="qa-wide-modal">
      <Modal.Body>
        <Modal.Title>
          <h3>Submit to Customaite</h3>
        </Modal.Title>

        {!documentsList.length ? (
          <>
            <p className="pt-2 mb-1 text-danger">No documents selected.</p>
            <p className="text-danger">
              Please use the 'Actions' button to view a document and select the document to submit to Customaite.
            </p>
          </>
        ) : (
          <>
            <p className="pt-2 mb-1">The documents below have been selected for Customaite.</p>
            <p className="pb-3">Please check the below documents are correct and then submit to Customaite</p>

            <DataTable data={documentsList} className="table-bordered">
              <DataTable.Row style={{ fontSize: '14px' }} />

              <DataTable.Column colKey="documentType" header="document type" />
              <DataTable.Column colKey="filename" header="filename" maxWidth="50ch" />
            </DataTable>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex w-100 align-items-center justify-content-between gap-3">
          <button
            type="button"
            class="blue-button-teams green-btn py-2"
            style={{ width: 'fit-content', minWidth: '220px' }}
            onClick={onHide}
            disabled={loading}
          >
            Close
          </button>
          <div className="text-danger text-end flex-grow-1">{error && 'Error submitting to Customaite.'}</div>
          <button
            type="button"
            className="blue-button-newload mt-0"
            style={{ width: 'fit-content', minWidth: '220px' }}
            onClick={() => {
              if (
                store.despatch[0] ||
                store.destination[0] ||
                store.officeOfDest[0] ||
                store.portsModal[0] ||
                store.consignor[0] ||
                store.consignee[0] ||
                store.shipStatus[0] ||
                store.truck[0] ||
                store.trailerSeal[0] ||
                store.container[0] ||
                store.poNumber[0] ||
                store.invoicecurr[0] ||
                store.selectincoterm[0] ||
                store.incotermLocation[0] ||
                store.controlledGoods[0]
              ) {
                setShowConfirmModal(true);
              } else {
                onSubmit(documentsList.map(({ id }) => id));
              }
            }}
            disabled={!documentsList.length || loading}
          >
            {loading ? <Spinner animation="border" size="lg" /> : 'Submit to Customaite'}
          </button>
        </div>
      </Modal.Footer>
      <ConfirmationModal
        show={showConfirmModal}
        onHide={() => setShowConfirmModal(false)}
        onConfirm={async () => {
          onSubmit(documentsList.map(({ id }) => id));
        }}
        centered
      >
        Data has already been added for this load. If you continue, existing data will be overwrritten.
      </ConfirmationModal>
    </Modal>
  );
};

export default CustomaiteModal;
